export const validateReportingDates = (startYear, startMonth, endYear, endMonth) => {
  if (!startYear || !startMonth || !endYear || !endMonth) {
    return "Reporting start and end dates are required";
  }
  const startDate = new Date(startYear, startMonth);
  const endDate = new Date(endYear, endMonth);
  return startDate < endDate || "Start date must be earlier than end date";
};

// helper function to map number months to month names
export const getMonthName = (month) => {
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  return monthNames[month];
};

/**
 @deprecated Use Date() or an ISO-standard string instead of a custom format
 * @param {*} date 
 * @returns 
 */
export const formatDateForAPI = (date) => {
  const { day, month, year } = date;
  if (!day || !month || !year) return null;
  const formattedDate = new Date(`${year}-${month}-${day}`);
  return formattedDate.toISOString();
};

/**
 @deprecated Use Date() or an ISO-standard string instead of a custom format
 * @returns 
 */
export const getCurrentDate = () => {
  const currentDate = new Date();
  return {
    day: String(currentDate.getDate()).padStart(2, "0"),
    month: String(currentDate.getMonth() + 1).padStart(2, "0"),
    year: String(currentDate.getFullYear()),
  };
};

// TODO refactor to edit the selectedRound object in place
export const mapSelectedRoundToFormDefaults = (selectedRound) => {
  const { name, packageId, startMonth, startYear, endMonth, endYear, ownerEmails, entities } = selectedRound;

  // Convert owners to { value, label }
  const _owners = ownerEmails?.map((email) => {
    return {
      value: email,
      label: email, // fallback to email if label not found
    };
  });

  // Convert entities to { value, label }
  const _entities = entities?.map((id) => {
    return {
      value: id,
      label: id,
    };
  });

  return {
    id: selectedRound.id,
    name,
    _package: packageId,
    startMonth: String(startMonth),
    startYear: String(startYear),
    endMonth: String(endMonth),
    endYear: String(endYear),
    dateRange: "",
    _owners,
    _entities,
  };
};


/**
 * To avoid mismatch issues between the AI and the text-editor, standardise the html formatting
 * @param {string} html 
 * @returns {string}
 */
export function standardiseHtml(html) {
	if ( ! html) {
		console.warn("standardiseHtml: no html provided");
		return ""; // paranoia
	}
  // standardise before-closing-tag whitespace e.g. <h3>blah\n</h3> to <h3>blah</h3>
  html = html.replace(/\n+<\//g, "</");
  // remove tag attributes (but preserve the tag), except for cite tags where we want to preserve the attributes
  html = html.replace(/<(\w+)\s*([^>]*)>/g, (match, g1, g2) => {	
    if (g1 === "cite" || g1 === "img") {
      return match;
    }
	// TODO should we remove non-"basic" tags to match the RichTextEditor?
	const isSelfClosing = g2.endsWith("/");
	if (isSelfClosing) {
		return `<${g1.trim()}/>`;
	}
    return `<${g1.trim()}>`;
  });
  // line breaks after closing tags
  html = html.replace(/<\/([^>]+)>/g, "</$1>\n");
  // line break after <br/>
  html = html.replace(/<br\/>([^\n])/g, "<br/>\n$1");
  // no indents
  html = html.replace(/^[ \t]+/g, "");
 	// standardise newlines and whitespace
	html = html.replace(/[\r\n]+/g, "\n");
	html = html.replace(/[ \t]+/g, " ");
  // remove spaces in self-closing tags eg <br /> to <br/>
  html = html.replace(/<(\w+[^>]*?) *\/>/g, "<$1/>");
  return html;
}


/**
 * Standardise html formatting -- Is this better than standardiseHtml??
 * @param {*} content 
 */
export function standardiseHtml_v2(html, indent = '  ') {
	if ( ! html) return "";
	const tokens = html
	  .replace(/>\s+</g, '><')       // collapse inter-tag whitespace
	  .replace(/</g, '\n<')          // newlines before tags
	  .trim()
	  .split('\n');
  
	let depth = 0;
	return tokens.map(line => {
	  if (/^<\/|^<!\[endif\]|^-->|^<\/\w/.test(line)) depth = Math.max(depth - 1, 0);
	  const out = indent.repeat(depth) + line;
	  if (/^<(?!!|\/|meta|link|img|br|hr|input|source|area|col|base)\b[^>]*[^/]>$/.test(line)) depth++;
	  return out;
	}).join('\n');
  }


  /**
   * 
   * @param {string} before 
   * @param {string} find 
   * @param {string} replace 
   * @param {object} options 
   * @param {boolean} options.lenient 
   * @param {boolean} options.standardiseHtml 
   * @returns {string}
   */
  export function applyFindReplace(before, find, replace, options = {}) {	
	if ( ! before) {
		before = "";
	}
	if ( ! find) {
		return before + replace;
	}
	if (options?.standardiseHtml) {
		find = standardiseHtml(find);
		before = standardiseHtml(before);
	}
	// apply!
  let newContent = before.replace(find, replace);
  if (options?.standardiseHtml) {
	newContent = standardiseHtml(newContent);
  }
  if (newContent !== before) {
	return newContent;
  }
  if ( ! options?.lenient) {
    console.warn("(skip) No change in applyFindReplace", { before, find, replace });
	return newContent;
  }
  // create a regex from `find` that is case-insensitive, ignores whitespace, and ignores html-tags
  const anyGapOrTagOrNewline = "(\\s+|<[^>]+>|\r?\n)+";
  const anyGapOrTagOrNewlinePattern = new RegExp(anyGapOrTagOrNewline, "gi");
  let findPattern = find.replace(anyGapOrTagOrNewlinePattern, anyGapOrTagOrNewline);
  console.log("findPattern", findPattern, "from", find);
  // use this pattern to replace the find string in a lenient-match way
  const regex = new RegExp(findPattern, "gi");
  newContent = before.replace(regex, replace);
  if (options?.standardiseHtml) {
	newContent = standardiseHtml(newContent);
  }
  if (newContent !== before) {
	console.log("lenient match found", { before, find, findPattern, replace, newContent });
	return newContent;
  }
  console.warn("(skip) No change in lenient applyFindReplace", { before, find, replace });
  return newContent;
}

// Mirrors backend esgai/checks/citations.py's attribute-parsing regex (same LLM-authored <cite>
// format, parsed the same way in two places - keep them in lockstep).
export const CITE_TAG_RE = /<cite\b\s*([^>]*)>(.*?)<\/cite>/gis;
export const CITE_ATTR_RE = /([a-zA-Z0-9_-]+)=(?:\{([^}]*)\}|"([^"]*)"|\\"([^"]*)\\"|'([^']*)')/g;

/**
 * Renumber citations to avoid multiple [1]s and to use the same number for the same citation
 * (ESG-3952). Identity key = resolved data-source_id / data-question_id / data-url (in that
 * priority order, matching the backend's check_and_process_cite_tags() precedence) - NOT the raw
 * attribute string. Two <cite> tags citing the SAME source with attributes in a different order,
 * or one with data-page and one without (data-page is per-citation-instance metadata, not part
 * of source identity), must resolve to the same number - keying on the raw attribute string (the
 * previous implementation) would wrongly split them.
 *
 * A cite tag with none of the three identity attributes is left completely untouched (including
 * whatever text was already inside it) rather than dropped/renumbered - this runs on live editor
 * content, so it must never destroy an unrecognised tag shape.
 * @param {string} content
 * @returns {string} content
 */
export function applyCitationCounter(content) {
  if (!content) return content;
  const numberByIdentity = {};
  return content.replace(CITE_TAG_RE, (match, attrStr) => {
    const attrs = {};
    let attrMatch;
    CITE_ATTR_RE.lastIndex = 0;
    while ((attrMatch = CITE_ATTR_RE.exec(attrStr || "")) !== null) {
      const [, key, a, b, c, d] = attrMatch;
      const value = a ?? b ?? c ?? d;
      attrs[key.trim().toLowerCase().replace(/-/g, "_")] = (value || "").trim();
    }
    // data_foundation_uid: a Foundation Data v2 figure (utils/foundationAnswerLinks.js), written by a person or
    // by the AI - backend-python's _renumber_citations reads the same key.
    const identity = attrs.data_source_id || attrs.data_question_id || attrs.data_url || attrs.data_foundation_uid;
    if (!identity) {
      // No resolvable identity - leave this tag exactly as it was.
      return match;
    }
    let number = numberByIdentity[identity];
    if (!number) {
      number = Object.keys(numberByIdentity).length + 1;
      numberByIdentity[identity] = number;
    }
    // Reconstruct the opening tag from the ORIGINAL matched attribute text, not from attrs, so
    // untouched attribute order/quoting/whitespace is preserved - only the inner [N] changes.
    const openingTag = attrStr ? `<cite ${attrStr}>` : "<cite>";
    // A foundation figure's citation shows the approved figure before its number (ESG-4014). The attribute is
    // still entity-escaped, which is also how it must appear as element text.
    const figure = attrs.data_foundation_figure;
    return `${openingTag}${figure ? `${figure} ` : ""}[${number}]</cite>`;
  });
}
